<template>
  <div class="all-offers">
    <offerFilter v-if="showFilterModal" :tribes="allTribes" />
    <div class="all-offers__banner">
      <v-btn depressed fab x-small class="all-offers__banner__add-new">
        <router-link router :to="'/addOffer'">
          <font-awesome-icon icon="plus" />
        </router-link>
      </v-btn>
      <span
        @click="$router.push({ name: 'offerFilter', params: { tribes: allTribes } })"
        class="all-offers__banner__filter-btn"
      >Filters</span>
    </div>

    <div class="all-offers__container">
      <v-row v-if="queryResults.length < 1 && notFound === false" no-gutters>
        <v-col data-aos="rise" v-for="offer in allOffers" :key="offer.id" style="width: 300px;">
          <offer-card :offer="offer" @delete="deleteOffer(offer)" />
        </v-col>
      </v-row>

      <div style="width: 100%">
        <div data-aos="rise">
          <div v-for="offer in queryResults" :key="offer.id">
            <offer-card :offer="offer" @delete="deleteOffer(offer)" />
          </div>
        </div>
      </div>

      <div v-if="notFound">
        <h1 style="font-size: 80px; font-weight: 300; color: #3F51B5;">'{{ query }}' Not found...</h1>
      </div>
    </div>
    <span class="all-offers__pagination">
      <v-btn text @click="currentPage--">
        <font-awesome-icon icon="chevron-left" />
      </v-btn>
      <v-btn text @click="currentPage++">
        <font-awesome-icon icon="chevron-right" />
      </v-btn>
    </span>
  </div>
</template>

<script>
import Vue from "vue";
import addOffer from "@/components/offer/addOffer";
import addMerchant from "@/components/merchants/addMerchant";
import addOutlet from "@/components/outlets/addOutlet";
import offerCard from "@/components/offer/card";
import offerFilter from "@/components/offer/offerFilter";
import moment from "moment";
import { mapActions } from "vuex";
import { mapState } from "vuex";

export default {
  name: "allOffers",
  components: {
    addOffer,
    addMerchant,
    addOutlet,
    offerCard,
    offerFilter
  },

  data() {
    return {
      search: false,
      isVisible: false,
      showItems: false,
      offer: null,

      queryResults: [],
      notFound: false,

      dialogs: {
        editOffer: false,
        newOffer: false,
        merchant: false,
        outlet: false,
        filter: false
      },

      // Filters
      filter: {
        duration: {
          start: {
            hour: [],
            minute: []
          },
          end: {
            hour: [],
            minute: []
          },

          added: [
            "Today",
            "Yesterday",
            "Last 7 days",
            "Last 14 days",
            "Last 30 days"
          ]
        }
      },

      // pagination
      currentPage: 1,
      limit: 30,
      pages: 0,

      pageLoaded: false,

      itemsPerPage: ["30", "50", "100"]
    };
  },

  methods: {
    ...mapActions({
      getMerchant: "merchants/fetchOne",
      getOffers: "offers/fetchRawOffers"
    }),

    createMerchantUrl(merchant) {
      return `${process.env.VUE_APP_IMAGE_URL}/merchant/${merchant.id}_${merchant.logo}`;
    },

    createImageUrl(offer) {
      return `${process.env.VUE_APP_IMAGE_URL}/offer/${offer.id}_${offer.image}`;
    },

    async loadData(page) {
      this.getOffers(page).then(res => {
        this.allOffers.forEach(async offer => {
          await this.setMerchantData(offer);
        });
      });
    },

    setMerchantData(offer) {
      this.getMerchant(offer.merchant.id).then(merchant => {
        offer.merchant = merchant;
      });
    },

    selectedFilter() {
      return "accent";
    },

    onClick() {
      this.isVisible = !this.isVisible;
      if (this.isVisible) {
        setTimeout(
          () => document.addEventListener("click", this.clickOutEvent()),
          100
        );
      } else {
        this.close();
      }
    }
  },

  computed: {
    ...mapState({
      offers: state => state.offers,
      tribes: state => state.tribes,
      ui: state => state.ui
    }),

    allOffers() {
      return this.offers.items;
    },

    allTribes() {
      return this.tribes.items;
    },

    enter() {
      if (e.code === "Enter") {
        this.search = !search;
      }
    },

    showFilterModal() {
      return this.ui.toggleFilterModal;
    }
  },

  watch: {
    "offers.items": function(newVal, oldVal) {
      if (newVal[0] != oldVal[0]) {
        this.getOffers();
      }
    },

    async currentPage(val) {
      window.scrollTo(0, 0);
      this.loadData(val);
    },

    async query(val) {
      let results = this.allOffers.filter(offer => {
        return offer.title.includes(val);
      });

      if (results.length < 1) {
        this.notFound = true;
        this.queryResults = [];
      } else {
        this.queryResults = results;
        this.notFound = false;
      }
    }
  },

  mounted() {
    this.loadData(1);
  },

  destroyed() {
    AOS.refresh();
  }
};
</script>

<style lang="sass" scoped>
@import @/styles/variables.sass
@import @/styles/mixins.sass
@import @/styles/base.sass

.all-offers
  text-transform: none !important
  font-weight: 400

  &__banner
    display: flex
    justify-content: center
    padding-top: 20px

    &__add-new

      @include for-size(phone-only)
        position: relative
        left: 20px

    &__filter-btn
      position: absolute
      right: 30px

  &__container
    overflow-x: hidden

    @include for-size(phone-only)
      padding: 20px

  &__pagination
    display: flex
    justify-content: center

    &__filter-btn
      height: 48px
      width: 60px
      border-radius: 0
      transition: all .3s

      &:hover
        text-decoration: underline

[data-aos="rise"]
  opacity: 0
  transform: scale(1.2)

  &.aos-animate
    opacity: 1
    transform: scale(1)
</style>
